import { render, staticRenderFns } from "./showAuditoriumEdition.vue?vue&type=template&id=1a4af0de&scoped=true"
import script from "./showAuditoriumEdition.vue?vue&type=script&lang=js"
export * from "./showAuditoriumEdition.vue?vue&type=script&lang=js"
import style0 from "./showAuditoriumEdition.vue?vue&type=style&index=0&id=1a4af0de&prod&lang=css"
import style1 from "./showAuditoriumEdition.vue?vue&type=style&index=1&id=1a4af0de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4af0de",
  null
  
)

export default component.exports